import * as React from "react";
export const UserContext = React.createContext<any>(null);

const UserContextProvider = (props: any) => {
  const [user, setUser] = React.useState(null);
  return (
    <UserContext.Provider
      value={{
        user,
        setUser,
      }}
    >
      {props.children}
    </UserContext.Provider>
  );
};

export default UserContextProvider;
